import { useState, useEffect, useCallback } from 'react';

const useViewport = () => {
  const [viewportWidth, setViewportWidth] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);

  const updateDimensions = useCallback(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    setViewportWidth(width);
    setViewportHeight(height);
  }, []);

  useEffect(() => {
    updateDimensions();

    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, [updateDimensions]);

  return { viewportWidth, viewportHeight };
};

export default useViewport;
